module.exports = __webpack_public_path__ + "img/newsBg2.75359c0d.png";